"use client";

import React, { createContext, useContext, useEffect, useState } from "react";

interface ZenContextType {
  isStealthMode: boolean;
  toggleStealthMode: () => void;
  // Add other global Zen states here if needed
}

const ZenContext = createContext<ZenContextType | undefined>(undefined);

export function ZenProvider({ children }: { children: React.ReactNode }) {
  const [isStealthMode, setIsStealthMode] = useState(false);

  const toggleStealthMode = () => {
    setIsStealthMode((prev) => !prev);
  };

  return (
    <ZenContext.Provider value={{ isStealthMode, toggleStealthMode }}>
      {children}
    </ZenContext.Provider>
  );
}

export function useZenContext() {
  const context = useContext(ZenContext);
  if (context === undefined) {
    throw new Error("useZenContext must be used within a ZenProvider");
  }
  return context;
}
